import { groupBy } from 'relapp-helpers';
import { createVuexStore } from 'way2web-vuex-store';

const addSubscriptionName = subscription => {
    let subscriptionName = subscription.product_name;

    if (subscription.type === 'extension') {
        subscriptionName = subscription.domain;
    }

    return {
        ...subscription,
        name: subscriptionName
    };
};

export default {
    ...createVuexStore({
        getters: {
            servicesByDomain: state => groupBy(state.items.map(addSubscriptionName), 'domain'),
            /**
             * Get the service for the table data.
             *
             * @param {object} state
             *
             * @return {array}
             */
            servicesTableData(state) {
                let rows = groupBy(state.items.map(addSubscriptionName), 'domain');

                return Object.entries(rows)
                    .map(entry => {
                        const hostname = entry[0];
                        const services = entry[1];

                        let dns = false;

                        let domain = false;

                        let hosting = false;

                        let ssl = '';

                        let customer = '';

                        services.forEach(service => {
                            if (service.customer) {
                                customer = service.customer;
                            }
                            const productName = service.product_name;

                            switch (service.type) {
                                case 'dns':
                                    dns = true;
                                    break;
                                case 'extension':
                                    domain = true;
                                    dns = true;
                                    break;
                                case 'hosting':
                                    hosting = productName;
                                    dns = true;
                                    break;
                                case 'ssl':
                                    if (ssl) {
                                        ssl = ssl + ', ' + productName;
                                    } else {
                                        ssl = productName;
                                    }
                                    break;
                            }
                        });

                        return {
                            customer,
                            hostname,
                            domain,
                            dns,
                            hosting,
                            ssl
                        };
                    })
                    .filter(service => service.dns || service.domain || service.hosting || service.ssl);
            },
            domainServices: state =>
                state.items
                    .filter(service => service.type == 'extension' && service.administrative_status != 'deleted')
                    .map(service => service.domain),
            firstServiceForDomain: state => ({ domain }) =>
                state.items.map(addSubscriptionName).find(service => service.domain == domain),
            serviceForDomain: state => ({ domain, type }) =>
                state.items.map(addSubscriptionName).find(service => service.type == type && service.domain == domain),
            multipleServiceForDomain: state => ({ domain, type }) =>
                state.items.map(addSubscriptionName).filter(service => service.type == type && service.domain == domain)
        }
    })
};
